import { useState } from "react";
// api services
import apiParticipantes from "../api/Participantes/api-participantes";
// redux
import { useDispatch, useSelector } from "react-redux";
import {
  guardarDatosPostulacion,
  tipoParticipante,
} from "../redux/actions/participantesAction";
import { useNavigate } from "react-router";
import { RootState } from "../redux/reducers";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { useEncrypt } from "./useEncrypt";
import getStorageUser from "../middlewares/GetStorageUser"

export const useSeleccionarRoles = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [principalState, setPrincipalState] = useState(initialValues);

  const { decrypt, encrypt } = useEncrypt();
  const { datos_postulacion } = useSelector(
    (state: RootState) => state.participantes
  );

  const asociarRoles = async (tipo_participante: number) => {
    const id_postulacion = localStorage.getItem("id_postulacion");
    localStorage.setItem(
      "tipo_participante_postulacion",
      `${tipo_participante - 1}` 
    );
//Se resta uno debido a que los documentos evaluan a los tipos de participantes del 0 al 2 y no del 1 al 3 como al momento del registro
    if (id_postulacion == null) {
      if(!getStorageUser()) {
          navigate('/login');
          return;
      }
      const user = getStorageUser()
      dispatch(tipoParticipante(tipo_participante));
      dispatch(
        guardarDatosPostulacion({
          ...datos_postulacion,
          tipo_participante,
          principalState,
        })
      );
      const { data: convocatoria } = await apiConvocatorias.infoConvocatoria(
        decrypt(localStorage.getItem("idConvocatoriaPostulacion"))
      );
        //console.log(user);
        
      let payload = {
        convocatoria_id: decrypt(
          localStorage.getItem("idConvocatoriaPostulacion")
        ),
        numero_documento_participante: user.documento,
        linea_convocatoria: convocatoria[0].linea_convocatoria,
        secuencia: convocatoria[0].sec,
        tipo_participante: tipo_participante,
        documentos_administrativos: convocatoria[0].documentos_administrativos,
        documentos_tecnicos: convocatoria[0].documentos_tecnicos,
        estado: "Por guardar",
        tipo: 1,
      };

      let { data } = await apiParticipantes.crearPostulacion(payload);

      if (data) {
        localStorage.setItem(
          "id_postulacion",
          encrypt(data.id_postulacion.toString())
        );
      }
    }

    if (tipo_participante === 1) {
      return navigate("/Usuario/Personanatural/");
    }
    if (tipo_participante === 2) {
      return navigate("/Usuario/Personajuridica/");
    }
    if (tipo_participante === 3) {
      return navigate("/Usuario/Grupoconformado/");
    }
  };

  const cambioCheckBox = (e: any, input: string) => {
    console.log(e);
    //
    // //console.log(e.target.value)
    setPrincipalState({
      ...principalState,
      [input]: e.target.checked,
    });
  };

  const atras = () => {
    return navigate("/verconvocatoria");
  };

  return {
    principalState,
    setPrincipalState,
    asociarRoles,
    cambioCheckBox,
    atras,
  };
};

const initialValues = {
  Gestor: true,
  Creador: false,
  tipo_participante: null,
};
